module.exports = __webpack_public_path__ + "static/media/ZPA.a568062d.pdf";